<template>
<section class="homeContact">
  <div id="contact" class="homeContact-background"></div>
  <div class="homeContact-container">
    <div class="homeContact-form">
      <h2 class="homeContact-title">Contact me</h2>
      <div class="inputGroup" :class="{ _error: $v.name.$error }">
        <label class="inputGroup-label" for="name">Name</label>
        <input id="name" class="inputGroup-input" v-model.trim="$v.name.$model" />
        <div class="error" v-if="$v.name.$error && !$v.name.required">Field is required</div>
      </div>
      <div class="inputGroup" :class="{ _error: $v.email.$error }">
        <label class="inputGroup-label" for="email">E-mail</label>
        <input id="email" class="inputGroup-input" v-model.trim="$v.email.$model" />
        <div class="error" v-if="$v.email.$error && !$v.email.required">Field is required</div>
        <div class="error" v-if="$v.email.$error && !$v.email.email">Email is invalid</div>
      </div>
      <div class="inputGroup" :class="{ _error: $v.message.$error }">
        <label class="inputGroup-label" for="message">Message</label>
        <input id="message" class="inputGroup-input" v-model.trim="$v.message.$model" />
        <div class="error" v-if="$v.message.$error && !$v.message.required">Field is required</div>
      </div>
      <div class="button _submit" :class="{ _loading: submitStatus == 'loading...' }" @click="submit">{{ submitStatus }}</div>
    </div>
    <div class="homeContact-info">
      <div class="infoBlock">
        <div class="infoBlock-contacts">
          <div class="infoBlock-title">Contacts</div>
          <a class="infoBlock-contact" href="mailto:ian.hurdle@theagencyre.com">
            <span class="infoBlock-text">ian.hurdle@theagencyre.com</span>
          </a>
          <a class="infoBlock-contact" href="tel:6492471993">
            <span class="infoBlock-text">649.332.2612</span>
          </a>
        </div>
        <div class="infoBlock-location">
          <div class="infoBlock-title">Location</div>
          <span class="infoBlock-text">7/8 Salt Mills Plaza, Grace Bay Road</span>
          <span class="infoBlock-text">Turks &amp; Caicos, TKCA1ZZ</span>
        </div>
        <div class="infoBlock-socials">
          <div class="infoBlock-title">Follow me</div>
          <Social class="infoBlock-socials-wrapper" />
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
  import { validationMixin } from 'vuelidate';
  import { required, email } from 'vuelidate/lib/validators';
  export default {
    mixins: [validationMixin],
    data() {
      return {
        submitStatus: 'send request',
        name: '',
        email: '',
        message: '',
      };
    },
    components: {
      SvgComponent: () => import('@/components/SvgComponent'),
      Social: () => import('@/components/Social'),
      
    },
    validations: {
      name: { required },
      email: { required, email },
      message: {},
    },
    methods: {
      async submit() {
        if (this.submitStatus == 'OK' || this.submitStatus == 'loading...') {
          return;
        }
        console.log('submit!');
        this.$v.$touch();
        if (this.$v.$invalid) {
          console.log('form is invalid!');
          this.submitStatus = 'invalid form';
        } else {
          this.submitStatus = 'loading...';
          const res = await this.$store.dispatch('sendEmail', {
            name: this.name,
            email: this.email,
            message: this.message,
          });
          this.submitStatus = res.statusText;
          this.$router.push({ name: 'SuccessPage' });
        }
      },
    },
  };
</script>

<style lang="scss">
  .homeContact {
    color: #FFFAF3;
    
    
    &-title {
      margin-bottom: 24px;
      font-family: 'Abhaya Libre';
      @include small {
        margin-bottom: 40px;
      }
      @include tablet {
        margin-bottom: 0px;
        //  margin-top: 56px;
        text-align: left;
        font-size: 40px;
      }
    }
    display: contents;
    &-divider {
      width: 2px;
      flex-shrink: 0;
      //  height: 100%;
      background: #c4c4c4;
      margin: 0 150px;
      // align-self: stretch;

      // flex-grow: 1;
      @include middle {
        margin: 0 90px 0 45px;
      }
      @include small {
        margin: 0 px;
      }
    }
    &-background {
      background: #1F1E1E;
    }
    &-container {
      padding: 120px 0 60px;
      display: flex;
      justify-content: space-between;
      
      
      @include middle {
        padding: 100px 0 40px;
      }
      @include small {
        padding: 80px 0 25px;
      }

      @include tablet {
        padding: 60px 120px 60px 0;
        gap: 100px;
      }

      @include miniTablet {
        padding: 60px 0 60px 0;
        gap: 70px;
      }

      @include phone {
        flex-direction: column;
        padding: 60px 0;
      }
      // align-items: center;
    }
    &-info {
      // flex-grow: 1;
      // width: 50%;
      /* width: 336px; */
      @include tablet {
        width: auto;
      }
    }
    &-form {
      // flex-grow: 1;
      // width: 50%;
      width: 393px;
      // padding: 0 150px;
      @include gap(37px, col);
      display: flex;
      flex-direction: column;
      @include tablet {
        margin-top: 0px;
        width: 100%;
      }
    }
    .inputGroup {
      // height: 61px;
      border-bottom: 1px solid #c4c4c4;
      padding-bottom: 10px;
      /* padding-left: 20px; */
      position: relative;

      @include phone {
        margin-top: 32px;
      }
      &-label {
        display: block;
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: 800;
      }
      &-input {
        font-size: 18px;
        width: 100%;
      }
      &._error {
        border-color: $red;
      }
      .error {
        position: absolute;
        bottom: -1.5em;
        left: 0px;
        font-size: 16px;
        line-height: 19px;
        color: $red;
      }
    }

    .infoBlock {
      margin-top: 64px;
      display: grid;
      grid-template-columns: repeat(2, 285px);
      gap: 32px;

      @include tablet {
        margin-top: 56px;
        grid-template-columns: 1fr;
        gap: 26px;
      }

      &-contact{
        display: flex;
        align-items: center;
        
      }

      &-title { 
        font-weight: 700;
        font-size: 24px;
        line-height: 36px;

        @include tablet {
          font-size: 22px;
          line-height: 36px;
          margin-bottom: 4px;
        }

        @include phone {
          font-size: 20px;
          line-height: 20px;
          margin-bottom: 12px;
        }
      }
      &-text{
        line-height: 36px;

        @include tablet {
          font-size: 16px;
          line-height: 36px;
        }

        @include phone {
          font-size: 16px;
          line-height: 26px;
          margin-bottom: 8px;
        }
      }

      &-socials-wrapper{
        display: flex;
        align-items: center;
        gap: 6px;
        margin-top: 10px;
      }



    }

    .contactBlock {
      @include gap(20px, col);
      @include tablet {
        border: solid 5px white;
        padding: 32px;
        svg {
          flex-shrink: 0;
        }
      }
      &-name {
        font-weight: 600;
        font-size: 30px;
      }
      &-rank {
        font-weight: 300;
        font-size: 16px;
      }
      &-contact {
        font-size: 20px;
        line-height: 36px;
        display: flex;
        align-items: center;
        @include gap(20px, row);
        svg {
          color: #d41e34;
        }
        @include tablet {
          font-size: 20px;
        }
      }
    }
  }
</style>
